import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import Navbar from "../nav/Navbar";
import "./Layout.css";

const TestLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMobileSidebarOpen(false); // Close mobile sidebar on desktop
        setIsSidebarCollapsed(false); // Default to expanded on desktop
      } else {
        setIsMobileSidebarOpen(false); // Close sidebar on mobile/tablet initially
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
    if (window.innerWidth < 1024) {
      setIsMobileSidebarOpen(!isMobileSidebarOpen);
    }
  };

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
    <div className="layout flex w-full h-screen overflow-hidden">
      <Navbar
        isCollapsed={isSidebarCollapsed}
        isMobileOpen={isMobileSidebarOpen}
        onCloseMobile={closeMobileSidebar}
      />
      <div
        className={`content-area flex flex-col flex-grow min-h-screen transition-all duration-300 ${
          isSidebarCollapsed ? "expanded" : "not-expanded"
        } ${isMobileSidebarOpen ? "mobile-sidebar-open" : ""}`}
      >
        <Header
          onMobileSidebarToggle={() => setIsMobileSidebarOpen(true)}
          toggleSidebar={toggleSidebar}
          isSidebarCollapsed={isSidebarCollapsed}
          isMobileSidebarOpen={isMobileSidebarOpen}
        />
        <main className="flex-grow overflow-y-auto p-4 sm:p-6 lg:p-8">
          <Outlet />

        </main>
        <div
          className={`overlay ${isMobileSidebarOpen ? "active" : ""}`}
          onClick={closeMobileSidebar}
        />
        
      </div>
    </div>
  );
};

export default TestLayout;